<template lang="pug">
div
    div.label
    .cadastrante-header {{ tipoCadastrante }}
    div(
      v-if="isAssociacaoJuridicamenteConstituida || isEntidadeRepresentativa",
      key="associacaoEntidade"
    )
      app-display(
        label="CNPJ:",
        :content="cadastrantePessoaJuridica.cnpj",
        :class = "mudouEspeciaisCadastrante.mudouPessoa.mudouCNPJ ? 'text': '' "
      )
      app-display(
        label="Razão Social:",
        :content="cadastrantePessoaJuridica.razaoSocial",
        :class = "mudouEspeciaisCadastrante.mudouPessoa.mudouRazaoSocial ? 'text': '' "
      )
      app-display(
        label="E-mail:",
        :content="cadastrantePessoa.email",
        :class = "mudouEspeciaisCadastrante.mudouPessoa.mudouEmail ? 'text': '' "
      )

      div(
        v-if="isAssociacaoJuridicamenteConstituida",
        key="associacao"
      )
      div(
        v-else,
        key="entidade"
      )
        el-collapse(v-model="representanteId")
          el-collapse-item(
            v-for="representante in cadastrante.representantes",
            :key="representante.id",
            :name='representante.id',
            :title="representante.pessoa.pessoaFisica.nome"
          )
            app-display(
              label="CPF:",
              :content="representante.pessoa.pessoaFisica.cpf",
              :class = "mudouEspeciaisCadastrante.mudouPessoa.mudouCPF ? 'text': '' "
            )
            app-display(
              label="RG:",
              :content="representante.pessoa.pessoaFisica.rg",
              :class = "mudouEspeciaisCadastrante.mudouPessoa.mudouRG ? 'text': '' "
            )
            app-display(
              label="Cargo/Função:",
              :content="representante.cargoFuncao",
              :class = "mudouEspeciaisCadastrante.mudouRepresentanteLegal.mudouCargoFuncaoRepresentante ? 'text': '' "
            )

    div(
      v-else-if="isOficioPresidente",
      key="oficio"
    )
      p.margin-top(v-html="cadastrante.despacho")

    div(
      v-else,
      key="membros"
    )
      el-collapse(v-model="membroId")
        el-collapse-item(
          v-for="membroComunidade in cadastrante.membrosComunidade",
          :key="membroComunidade.id",
          :name='membroComunidade.id',
          :title="membroComunidade.pessoa.pessoaFisica.nome"
        )
          app-display(
            label="CPF:",
            :content="membroComunidade.pessoa.pessoaFisica.cpf",
            :class = "mudouEspeciaisCadastrante.mudouMembroComunidade.mudouPessoa.mudouCPF ? 'text': '' "
          )
          app-display(
            label="Telefone(s):",
            :content="membroComunidade.pessoa.listaTelefones",
            :class = "mudouEspeciaisCadastrante.mudouMembroComunidade.mudouPessoa.mudouTelefones ? 'text': '' "
          )
          app-display(
            label="E-mail:",
            :content="membroComunidade.pessoa.email",
            :class = "mudouEspeciaisCadastrante.mudouMembroComunidade.mudouPessoa.mudouEmail ? 'text': '' "
          )
          el-collapse(
            value="0",
            v-if="showMembroEndereco"
          )
            el-collapse-item(
              title="Endereço",
              name="0"
            )
              informacoes-endereco(:endereco="membroComunidade.pessoa.endereco", slot="body", :mudouEndereco = "mudouEspeciaisCadastrante.mudouMembroComunidade.mudouEndereco")
</template>

<script>
import _ from 'lodash'
import AppDisplay from '../AppDisplay'
import InformacoesEndereco from './InformacoesEndereco'

export default {

  components: {
    AppDisplay,
    InformacoesEndereco
  },

  props: {
    cadastrante: {
      type: Object,
      required: false
    },
    isOnerosoGroup: {
      type: Boolean,
      required: true
    },
    mudouEspeciaisCadastrante: {
      type: Object,
      required: false
    }
  },

  data () {
    return {
      representanteId: null,
      membroId: null
    }
  },

  computed: {
    isAssociacaoJuridicamenteConstituida () {
      return this.cadastrante.tipo === 'ASSOCIACAO_JURIDICA_CONSTITUIDA'
    },
    isEntidadeRepresentativa () {
      return this.cadastrante.tipo === 'ENTIDADE_REPRESENTATIVA'
    },
    isOficioPresidente () {
      return this.cadastrante.tipo === 'DE_OFICIO_DO_PRESIDENTE'
    },
    cadastrantePessoa () {
      return this.cadastrante.pessoa
    },
    cadastrantePessoaJuridica () {
      return this.cadastrantePessoa.pessoaJuridica
    },
    tipoCadastrante () {
      let tipo
      switch (this.cadastrante.tipo) {
        case 'ASSOCIACAO_JURIDICA_CONSTITUIDA':
          tipo = 'Associação Juridicamente Constituída'
          break
        case 'ENTIDADE_REPRESENTATIVA':
          tipo = 'Entidade Representativa'
          break
        case 'MEMBROS_DA_COMUNIDADE':
          tipo = 'Membros da Comunidade'
          break
        case 'DE_OFICIO_DO_PRESIDENTE':
          tipo = 'De Ofício do Presidente'
          break
        default:
      }
      return tipo
    }
  },

  created () {
    this.representanteId = this.cadastrante.representantes && this.cadastrante.representantes.length > 0
      ? _.cloneDeep(this.cadastrante.representantes).pop().id : null
    this.membroId = this.cadastrante.membrosComunidade && this.cadastrante.membrosComunidade.length > 0
      ? _.cloneDeep(this.cadastrante.membrosComunidade).pop().id : null
  }

}
</script>

<style scoped lang="scss">

  .label-format {
    font-size: 15px;
    margin-top: 2vh;
    color: #444444;
  }

  .cadastrante-header {
    color: #444444;
    cursor: pointer;
    font-weight: bold;
    font-size: inherit;
    margin-bottom: 1vh;
  }

  p.despacho {
    font-weight: bold;
  }

  .label {
    display: block;
    align-self: start;
  }

  >>> .text .text{
    color: #ff0000 !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/InformacoesEspeciaisCadastrante.vue